<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <RelativeRelationForm
      v-if="!isLoading"
      :relativeRelationData="relativeRelation"
      :submitName="$t('add')"
      v-on:addOrUpdateRelativeRelation="addRelativeRelation()"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import RelativeRelationForm from "@/components/settings/settingsOther/relativeRelations/RelativeRelationForm.vue";
import createToastMixin from "@/utils/create-toast-mixin";
import RelativeRelation from "@/models/settings/settingsOther/relativeRelations/RelativeRelation";

export default {
  name: "RelativeRelationAdd",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    RelativeRelationForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      relativeRelation: new RelativeRelation(),
    };
  },
  methods: {
    async addRelativeRelation() {
      this.isLoading = true;

      try {
        let response = await this.relativeRelation.addOrUpdateRelativeRelation(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.relativeRelation.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped lang="scss"></style>
